import { graphql } from 'gatsby';
import Cookies from 'js-cookie';
import get from 'lodash.get';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';

import ArticleWithToC from '../components/Common/ArticleWithToC';
import PageSection from '../components/Common/PageSection';
import ScrollTo, { smoothScrollToRef } from '../components/Common/ScrollTo';
import Layout, { BACKGROUND } from '../components/Layouts/Layout';
import LearningCenterSeo from '../components/LearningCenter/LearningCenterSeo';
import HeadingWithForm from '../components/LearningCenter/PostHeaders/HeadingWithForm';

const LearningPost = ({ data, location }) => {
  const content = data.post;
  const backgroundImage = get(content, 'headingBackground.file.url');
  const typeName = get(content, 'type.typeName');

  const formData = {
    title: content.title,
    successCopy: get(content, 'submissionSuccessMessage'),
    fileUrl: get(content, 'downloadableContent.file.url', ''),
    contentIsDownloadable: content.contentIsDownloadable,
    heroImage: content.heroImage,
    marketoFormId: content.marketoFormId,
    dynamicForm: content.marketoDynamicForm,
  };

  let tableOfContents = [];
  if (content.walledContentTableOfContents && content.walledContentTableOfContents.group) {
    tableOfContents = content.walledContentTableOfContents.group.map((item) => {
      return {
        title: item.title,
        url: `#${item.sectionId}`,
        id: item.sectionId,
      };
    });
  }

  const [unlocked, setUnlocked] = useState(false);
  const scrollRef = useRef();
  const onSuccess = async () => {
    if (!unlocked) {
      await setUnlocked(true);
    }
    if (scrollRef && scrollRef.current) {
      smoothScrollToRef(scrollRef, null, 84);
    }
  };

  const COOKIE = '_fs_lcaccess';
  const unlockedCookie = Cookies.get(COOKIE);
  if (!unlocked && unlockedCookie && content.walledContentBody) {
    onSuccess();
  }
  let trackingPixelUrl =
    content.pageMeta?.trackingPixelUrl ||
    'https://px.ads.linkedin.com/collect/?pid=209369&conversionId=6567314&fmt=gif';

  return (
    <Layout background={BACKGROUND.GREY}>
      <LearningCenterSeo meta={content.pageMeta} slug={location.pathname} />
      <div className={'publish-date'} data-post-date={content.publishDate} />
      <HeadingWithForm
        id={'hero-section'}
        title={content.title}
        headingFontColor={content.headingFontColor}
        backgroundImageUrl={backgroundImage}
        formData={formData}
        super={typeName}
        excerpt={get(content, 'excerpt')}
        onSuccess={onSuccess}
        trackingPixelUrl={trackingPixelUrl}
        uniqueTrackingPixel={content.uniqueTrackingPixel}
        downloadCtaLabel={content.downloadCtaLabel}
        //alreadySubmitted={unlocked}
      />
      {unlocked && content.walledContentBody && (
        <>
          <ScrollTo reference={scrollRef} />
          <PageSection slim>
            <ArticleWithToC
              onScrollToTop={onSuccess}
              id={'article'}
              style={{ borderTop: '1px solid black', paddingTop: '16px' }}
              location={location}
              article={content.walledContentBody}
              tableOfContents={tableOfContents}
            />
          </PageSection>
        </>
      )}
    </Layout>
  );
};

export const pageQuery = graphql`
  query GetLearningCenterWalledContent($pageId: String!) {
    post: contentfulResourceCenterWalledContent(contentful_id: { eq: $pageId }) {
      ...ResourceCenterWalledContent
    }
  }
`;

LearningPost.propTypes = {
  data: PropTypes.object,
  location: PropTypes.any,
};

export default LearningPost;
